// extracted by mini-css-extract-plugin
export var container = "_4y-0";
export var fallback = "_4y-5";
export var fallbackIcon = "_4y-6";
export var hidden = "_4y-2";
export var image = "_4y-3";
export var loaded = "_4y-4";
export var placeholder = "_4y-1";